import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import CurrentClientProvider from '../../providers/CurrentClientProvider'
import { shouldHydrateClientContext } from '../../components/layout/ClientMiddleware'
import ClientProgress from '../../components/dashboard/ClientProgress'

// This route is the legacy dashboard boundary. Do not redirect this URL based
// on user, client, or persisted-session feature flags.
export default function ClientDashboardEntryRoute() {
  const { client_code } = useParams()
  const navigate = useNavigate()
  const currentClientContext = CurrentClientProvider.useClient() as any
  const currentClient = currentClientContext?.client

  if (shouldHydrateClientContext(currentClient, client_code)) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center px-6 py-12">
        <div className="text-center text-sm text-gray-500">Loading dashboard...</div>
      </div>
    )
  }


  return <ClientProgress onToggleBack={() => navigate('/')} />
}

